import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import { AccordionContext, } from './AccordionContext';
import { colors, types, } from './constants';
const accordionStyles = css `
  ${styleUtils.borderBox}
  width: 100%;
`;
const defaultProps = {
    folderColor: colors.light,
    folderType: types.standard,
    titleSize: 'medium',
};
const Accordion = ({ children, disabled, folderColor = defaultProps.folderColor, folderType = defaultProps.folderType, titleSize = defaultProps.titleSize, }) => {
    const accordionContextValue = (useMemo(() => ({
        disabled,
        folderColor,
        folderType,
        titleSize,
    }), [
        disabled,
        folderColor,
        folderType,
        titleSize,
    ]));
    return (_jsx("div", Object.assign({ css: accordionStyles }, { children: _jsx(AccordionContext.Provider, Object.assign({ value: accordionContextValue }, { children: children })) })));
};
const MemoizedAccordion = memo(Accordion);
export { MemoizedAccordion as Accordion };
// MC-1068 Temporary hack for Storybook.
export default Accordion;
